import * as EN from '../translations/en'
import * as FR from '../translations/fr'

export default class TranslationUtilities {
    /**
     * Method generates the needed data for the header of all our requests
     * @returns an object with the needed data to process the header of our requests
     */
    static getTranslations = lang => {
        if (lang === 'fr') {
            return FR.LANG
        }

        return EN.LANG
    }
}
